// extracted by mini-css-extract-plugin
export default {"FAQsContainer":"FAQ_FAQsContainer__DSLKP"};